import { render } from "./Panel.vue?vue&type=template&id=6816ff66&scoped=true"
import script from "./Panel.vue?vue&type=script&lang=js"
export * from "./Panel.vue?vue&type=script&lang=js"

import "./Panel.vue?vue&type=style&index=0&id=6816ff66&scoped=true&lang=css"
import "./Panel.vue?vue&type=style&index=1&id=6816ff66&lang=css"
script.render = render
script.__scopeId = "data-v-6816ff66"

export default script